import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
// get language list
export function languageList(){
	const data = request({
		url: config.url+'language/getDataList',
		method: 'get',
	});

	return Promise.resolve(data);
}

// language
export function languageAjaxTable(){
	const data = request({
		url: config.url+'language/ajaxTable',
		method: 'get'
	});

	return Promise.resolve(data);
}

export function languageLimit(value){
	const data = request({
		url: config.url+'language/ajaxTable?limit=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function languagePagination(value,limit){
	const data = request({
		url: config.url+'language/ajaxTable?pagination=' + value + '&limit=' + limit,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function languageSearch(id,code,category,filter,sort,status){
	const data = request({
		url: config.url+'language/ajaxTable?id=' + id + '&code=' + code + '&category=' + category + '&filter=' + filter + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function languageAdd(postData){
	const data = request({
		url: config.url+'language/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getLanguageEdit(code){
	const data = request({
		url: config.url+'language/edit?code=' + code,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function languageEdit(postData){
	const data = request({
		url: config.url+'language/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function languageDelete(postData){
	const data = request({
		url: config.url+'language/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// setting 
export function settingAjaxTable(limit,pagination,id,category,code,value){
	const data = request({
		url: config.url+'setting/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&category=' + category + '&code=' + code + '&value=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function settingAdd(postData){
	const data = request({
		url: config.url+'setting/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSettingEdit(id){
	const data = request({
		url: config.url+'setting/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function settingEdit(postData){
	const data = request({
		url: config.url+'setting/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function settingDelete(postData){
	const data = request({
		url: config.url+'setting/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// status
export function setting_statusAjaxTable(limit,pagination,id,category,code,status){
	const data = request({
		url: config.url+'status/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&category=' + category + '&code=' + code + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_statusAdd(postData){
	const data = request({
		url: config.url+'status/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSetting_StatusEdit(id){
	const data = request({
		url: config.url+'status/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function setting_statusEdit(postData){
	const data = request({
		url: config.url+'status/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_statusDelete(postData){
	const data = request({
		url: config.url+'status/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// attribute
export function setting_attributeAjaxTable(limit,pagination,id,code,category,filter,sort,status){
	const data = request({
		url: config.url+'attribute/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&category=' + category + '&filter=' + filter + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_attributeAdd(postData){
	const data = request({
		url: config.url+'attribute/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSetting_AttributeEdit(id){
	const data = request({
		url: config.url+'attribute/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function setting_attributeEdit(postData){
	const data = request({
		url: config.url+'attribute/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_attributeDelete(postData){
	const data = request({
		url: config.url+'attribute/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// wallet
export function setting_walletAjaxTable(limit,pagination,id,code,decimal,remark,sort,status){
	const data = request({
		url: config.url+'wallet/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&decimal_number=' + decimal + '&remark=' + remark + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_walletAdd(postData){
	const data = request({
		url: config.url+'wallet/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSetting_WalletEdit(id){
	const data = request({
		url: config.url+'wallet/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function setting_walletEdit(postData){
	const data = request({
		url: config.url+'wallet/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_walletDelete(postData){
	const data = request({
		url: config.url+'wallet/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// package
export function setting_packageAjaxTable(limit,pagination,id,code,sales_value,bonus_value,filter,sort,status){
	const data = request({
		url: config.url+'package/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&sales_value=' + sales_value + '&bonus_value=' + bonus_value + '&filter=' + filter + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_packageAdd(postData){
	const data = request({
		url: config.url+'package/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSetting_PackageEdit(id){
	const data = request({
		url: config.url+'package/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function setting_packageEdit(postData){
	const data = request({
		url: config.url+'package/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_packageDelete(postData){
	const data = request({
		url: config.url+'package/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_packageAttributeAjaxTable(id){
	const data = request({
		url: config.url+'package_attribute/ajaxTable?package_id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_packageAttributeAdd(postData){
	const data = request({
		url: config.url+'package_attribute/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSetting_PackageAttributeEdit(id){
	const data = request({
		url: config.url+'package_attribute/edit?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_packageAttributeEdit(postData){
	const data = request({
		url: config.url+'package_attribute/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_packageAttributeDelete(postData){
	const data = request({
		url: config.url+'package_attribute/DBdelete',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

export function setting_packageAttributeLimit(id,value){
	const data = request({
		url: config.url+'package_attribute/ajaxTable?package_id=' + id +'&limit=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function setting_packageAttributePagination(id,value,limit){
	const data = request({
		url: config.url+'package_attribute/ajaxTable?package_id=' + id + '&pagination=' + value + '&limit=' + limit,
		method: 'get'
	});

	return Promise.resolve(data);
}

// bonus payment method
export function setting_bonuspaymentAjaxTable(limit,pagination,id,at_id,attribute_id,package_id){
	const data = request({
		url: config.url+'bonuspayment/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&at_id=' + at_id + '&attribute_id=' + attribute_id + '&package_id=' + package_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getSetting_BonusPaymentAdd(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonuspayment/add?language='+language,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function setting_bonuspaymentAdd(postData){
	const data = request({
		url: config.url+'bonuspayment/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSetting_BonusPaymentEdit(id){
	const data = request({
		url: config.url+'bonuspayment/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function setting_bonuspaymentEdit(postData){
	const data = request({
		url: config.url+'bonuspayment/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function setting_bonuspaymentDelete(postData){
	const data = request({
		url: config.url+'bonuspayment/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

//payment method
export function paymentAjaxTable(limit,pagination,id,code,formula,sort,status){
	const data = request({
		url: config.url+'payment/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&formula=' + formula + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function paymentLimit(value){
	const data = request({
		url: config.url+'payment/ajaxTable?limit=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function paymentPagination(value,limit){
	const data = request({
		url: config.url+'payment/ajaxTable?pagination=' + value + '&limit=' + limit,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getPaymentAdd(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'payment/add?language='+language,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function paymentAdd(postData){
	const data = request({
		url: config.url+'payment/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getPaymentEdit(id){
	const data = request({
		url: config.url+'payment/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function paymentEdit(postData){
	const data = request({
		url: config.url+'payment/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function paymentDelete(postData){
	const data = request({
		url: config.url+'payment/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// permission admin method
export function permissionAjaxTable(limit,pagination,id,category,code,file,path,status){
	const data = request({
		url: config.url+'admin_permission/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&category=' + category + '&code=' + code + '&file=' + file + '&path=' + path + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getPermissionAdd(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'admin_permission/add?language='+language,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function permissionAdd(postData){
	const data = request({
		url: config.url+'admin_permission/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getPermissionEdit(id){
	const data = request({
		url: config.url+'admin_permission/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function permissionEdit(postData){
	const data = request({
		url: config.url+'admin_permission/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function permissionDelete(postData){
	const data = request({
		url: config.url+'admin_permission/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// email
export function emailAjaxTable(limit,pagination,id,at_id,attribute_id,package_id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'email/ajaxTable?language=' + language +'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&at_id=' + at_id + '&attribute_id=' + attribute_id + '&package_id=' + package_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getEmailAdd(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'email/add?language='+language,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function emailAdd(postData){
	const data = request({
		url: config.url+'email/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getEmailEdit(id){
	const data = request({
		url: config.url+'email/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function emailEdit(postData){
	const data = request({
		url: config.url+'email/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function emailDelete(postData){
	const data = request({
		url: config.url+'email/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function emailInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'email/info?id=' + id + '&language=' + language,
		method: 'get',
	});

	return Promise.resolve(data);
}

// system payment method
export function systemPaymentAjaxTable(limit,pagination,id,status_id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'system_payment/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&status_id=' + status_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getSystemPaymentAdd(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'system_payment/add?language='+language,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function systemPaymentAdd(postData){
	const data = request({
		url: config.url+'system_payment/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSystemPaymentEdit(id){
	const data = request({
		url: config.url+'system_payment/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function systemPaymentEdit(postData){
	const data = request({
		url: config.url+'system_payment/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function systemPaymentDelete(postData){
	const data = request({
		url: config.url+'system_payment/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function systemPaymentInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'system_payment/info?id=' + id + '&language=' + language,
		method: 'get',
	});

	return Promise.resolve(data);
}

// bank
export function bankAjaxTable(limit,pagination,id,code,category,filter,sort,status){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bank/ajaxTable?language=' + language + '&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&category=' + category + '&filter=' + filter + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function bankAdd(postData){
	const data = request({
		url: config.url+'bank/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getBankEdit(id){
	const data = request({
		url: config.url+'bank/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function bankEdit(postData){
	const data = request({
		url: config.url+'bank/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function bankDelete(postData){
	const data = request({
		url: config.url+'bank/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// payee
export function payeeAjaxTable(limit,pagination,id,code,category,filter,sort,status){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'payee/ajaxTable?language=' + language +'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&category=' + category + '&filter=' + filter + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function payeeAdd(postData){
	const data = request({
		url: config.url+'payee/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getPayeeEdit(id){
	const data = request({
		url: config.url+'payee/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function payeeEdit(postData){
	const data = request({
		url: config.url+'payee/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function payeeDelete(postData){
	const data = request({
		url: config.url+'payee/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// badge
export function badgeAjaxTable(limit,pagination,id,code,remark,sort,status,name){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'badge/ajaxTable?language=' + language + '&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&remark=' + remark + '&name=' + name + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeAdd(postData){
	const data = request({
		url: config.url+'badge/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getBadgeEdit(id){
	const data = request({
		url: config.url+'badge/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function badgeEdit(postData){
	const data = request({
		url: config.url+'badge/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function badgeDelete(postData){
	const data = request({
		url: config.url+'badge/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function badgeAttributeAjaxTable(id){
	const data = request({
		url: config.url+'badge_attribute/ajaxTable?badge_id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeAttributeAdd(postData){
	const data = request({
		url: config.url+'badge_attribute/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getBadgeAttributeEdit(id){
	const data = request({
		url: config.url+'badge_attribute/edit?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeAttributeEdit(postData){
	const data = request({
		url: config.url+'badge_attribute/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function badgeAttributeDelete(postData){
	const data = request({
		url: config.url+'badge_attribute/DBdelete',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

export function badgeAttributeLimit(id,value){
	const data = request({
		url: config.url+'badge_attribute/ajaxTable?badge_id=' + id +'&limit=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function badgeAttributePagination(id,value,limit){
	const data = request({
		url: config.url+'badge_attribute/ajaxTable?badge_id=' + id + '&pagination=' + value + '&limit=' + limit,
		method: 'get'
	});

	return Promise.resolve(data);
}

// rank
export function rankAjaxTable(limit,pagination,id,code,remark,sort,status,name){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'rank/ajaxTable?language=' + language +'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&remark=' + remark + '&name=' + name + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankAdd(postData){
	const data = request({
		url: config.url+'rank/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getRankEdit(id){
	const data = request({
		url: config.url+'rank/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function rankEdit(postData){
	const data = request({
		url: config.url+'rank/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function rankDelete(postData){
	const data = request({
		url: config.url+'rank/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function rankAttributeAjaxTable(id){
	const data = request({
		url: config.url+'rank_attribute/ajaxTable?rank_id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankAttributeAdd(postData){
	const data = request({
		url: config.url+'rank_attribute/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getRankAttributeEdit(id){
	const data = request({
		url: config.url+'rank_attribute/edit?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankAttributeEdit(postData){
	const data = request({
		url: config.url+'rank_attribute/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function rankAttributeDelete(postData){
	const data = request({
		url: config.url+'rank_attribute/DBdelete',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

export function rankAttributeLimit(id,value){
	const data = request({
		url: config.url+'rank_attribute/ajaxTable?rank_id=' + id +'&limit=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function rankAttributePagination(id,value,limit){
	const data = request({
		url: config.url+'rank_attribute/ajaxTable?rank_id=' + id + '&pagination=' + value + '&limit=' + limit,
		method: 'get'
	});

	return Promise.resolve(data);
}

// system 
export function systemAjaxTable(limit,pagination,id,code,value){
	const data = request({
		url: config.url+'system/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&value=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getSystemEdit(id){
	const data = request({
		url: config.url+'system/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function systemEdit(postData){
	const data = request({
		url: config.url+'system/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// versionMsg
export function versionMsgAjaxTable(limit,pagination,id,code,name,sort,status){
	const data = request({
		url: config.url+'versionmessage/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&name=' + name + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function versionMsgAdd(postData){
	const data = request({
		url: config.url+'versionmessage/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getVersionMsgEdit(id){
	const data = request({
		url: config.url+'versionmessage/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function versionMsgEdit(postData){
	const data = request({
		url: config.url+'versionmessage/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function versionMsgDelete(postData){
	const data = request({
		url: config.url+'versionmessage/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// coin 
export function coinAjaxTable(limit,pagination,id,category,code,value){
	const data = request({
		url: config.url+'coin/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&category=' + category + '&code=' + code + '&value=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function coinAdd(postData){
	const data = request({
		url: config.url+'coin/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getCoinEdit(id){
	const data = request({
		url: config.url+'coin/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function coinEdit(postData){
	const data = request({
		url: config.url+'coin/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function coinDelete(postData){
	const data = request({
		url: config.url+'coin/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// language message 
export function returnMessageAjaxTable(limit,pagination,id,category,code,value){
	const data = request({
		url: config.url+'returnmessage/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&category=' + category + '&code=' + code + '&value=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function returnMessageAdd(postData){
	const data = request({
		url: config.url+'returnmessage/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getReturnMessageEdit(id){
	const data = request({
		url: config.url+'returnmessage/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function returnMessageEdit(postData){
	const data = request({
		url: config.url+'returnmessage/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function returnMessageDelete(postData){
	const data = request({
		url: config.url+'returnmessage/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// setting page
export function settingPageAjaxTable(limit,pagination,id,code,name,sort,status){
	const data = request({
		url: config.url+'page/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&name=' + name + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function settingPageAdd(postData){
	const data = request({
		url: config.url+'page/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getSettingPageEdit(id){
	const data = request({
		url: config.url+'page/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function settingPageEdit(postData){
	const data = request({
		url: config.url+'page/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function settingPageDelete(postData){
	const data = request({
		url: config.url+'page/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function settingPageInfo(id){
	const data = request({
		url: config.url+'page/info?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

// mobileLink
export function mobileLinkAjaxTable(limit,pagination,id,code,category_id,link,remark,category){
	const data = request({
		url: config.url+'mobile_link/ajaxTable?language='+language+'&limit='+limit+'&pagination='+pagination+'&id='+id+'&code='+code+'&category_id='+category_id+'&category_id='+category_id+'&link='+link+'&remark='+remark+'&category='+category,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function mobileLinkAdd(postData){
	const data = request({
		url: config.url+'mobile_link/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getMobileLinkEdit(id){
	const data = request({
		url: config.url+'mobile_link/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function mobileLinkEdit(postData){
	const data = request({
		url: config.url+'mobile_link/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function mobileLinkDelete(postData){
	const data = request({
		url: config.url+'mobile_link/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// category
export function categoryAjaxTable(limit,pagination,id,code,category_id,link,remark,category){
	const data = request({
		url: config.url+'category/ajaxTable?language='+language+'&limit='+limit+'&pagination='+pagination+'&id='+id+'&code='+code+'&category_id='+category_id+'&category_id='+category_id+'&link='+link+'&remark='+remark+'&category='+category,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function categoryAdd(postData){
	const data = request({
		url: config.url+'category/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getCategoryEdit(id){
	const data = request({
		url: config.url+'category/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function categoryEdit(postData){
	const data = request({
		url: config.url+'category/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function categoryDelete(postData){
	const data = request({
		url: config.url+'category/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

// group
export function groupAjaxTable(limit,pagination,id,code,remark,sort,status,name){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'group/ajaxTable?language=' + language +'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&code=' + code + '&remark=' + remark + '&name=' + name + '&sort=' + sort + '&status=' + status,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function groupAdd(postData){
	const data = request({
		url: config.url+'group/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getGroupEdit(id){
	const data = request({
		url: config.url+'group/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function groupEdit(postData){
	const data = request({
		url: config.url+'group/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function groupDelete(postData){
	const data = request({
		url: config.url+'group/DBdelete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function groupAttributeAjaxTable(id){
	const data = request({
		url: config.url+'group_coin/ajaxTable?group_id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function groupAttributeAdd(postData){
	const data = request({
		url: config.url+'group_coin/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getGroupAttributeEdit(id){
	const data = request({
		url: config.url+'group_coin/edit?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function groupAttributeEdit(postData){
	const data = request({
		url: config.url+'group_coin/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function groupAttributeDelete(postData){
	const data = request({
		url: config.url+'group_coin/DBdelete',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

export function groupAttributeLimit(id,value){
	const data = request({
		url: config.url+'group_coin/ajaxTable?group_id=' + id +'&limit=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function groupAttributePagination(id,value,limit){
	const data = request({
		url: config.url+'group_coin/ajaxTable?group_id=' + id + '&pagination=' + value + '&limit=' + limit,
		method: 'get'
	});

	return Promise.resolve(data);
}